import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Clock, Video, Sparkles } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function WorkshopHero() {
  return <section className="relative pt-32 pb-20 lg:pt-44 lg:pb-28 overflow-hidden bg-brand-cream" data-id="element-2226">
      <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-gradient-to-br from-brand-gold/[0.08] to-brand-purple/[0.05] rounded-full blur-3xl -translate-x-1/2 -translate-y-1/4 animate-float pointer-events-none" data-id="element-2227" />

      <div className="max-w-5xl mx-auto px-6 relative z-10 text-center" data-id="element-2228">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-emerald-500/15 border border-emerald-500/40 text-emerald-700 text-xs md:text-sm font-bold uppercase tracking-[0.25em] mb-8" data-id="element-2229">
          <Sparkles className="w-4 h-4" data-id="element-2230" />
          Workshop Online · Gratuit
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-4xl md:text-5xl lg:text-[68px] leading-[1.1] font-bold text-brand-text mb-6 text-balance" data-id="element-2231">
          Cum Să Te Eliberezi de Blocajele Care Te Țin Departe de Abundență
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.15
      }} className="font-subtitle font-medium text-lg md:text-xl text-brand-textSec leading-relaxed text-balance max-w-3xl mx-auto mb-10" data-id="element-2232">
          Un workshop live și practic pentru oameni care simt că viața lor poate
          fi mai bună, dar se lovesc mereu de aceleași tipare. Descoperi ce te
          blochează, cum să transformi credințele din subconștient și care e
          primul pas concret spre o viață plină de abundență și liniște.
        </motion.p>

        {/* Event meta */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="flex flex-wrap items-center justify-center gap-3 md:gap-4 mb-10" data-id="element-2233">
          <div className="inline-flex items-center gap-2 bg-white border border-brand-text/10 px-4 py-2 rounded-full text-sm text-brand-text/80 shadow-sm" data-id="element-2234">
            <Calendar className="w-4 h-4 text-brand-gold" data-id="element-2235" />
            Dată în curând
          </div>
          <div className="inline-flex items-center gap-2 bg-white border border-brand-text/10 px-4 py-2 rounded-full text-sm text-brand-text/80 shadow-sm" data-id="element-2236">
            <Clock className="w-4 h-4 text-brand-gold" data-id="element-2237" />
            90 de minute
          </div>
          <div className="inline-flex items-center gap-2 bg-white border border-brand-text/10 px-4 py-2 rounded-full text-sm text-brand-text/80 shadow-sm" data-id="element-2238">
            <Video className="w-4 h-4 text-brand-gold" data-id="element-2239" />
            Online · pe Zoom
          </div>
          <div className="inline-flex items-center gap-2 bg-emerald-50 border border-emerald-200 px-4 py-2 rounded-full text-sm font-bold text-emerald-700 shadow-sm" data-id="element-2240">
            Gratuit
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.45
      }} className="flex justify-center" data-id="element-2241">
          <CTAButton data-id="element-2242" />
        </motion.div>
      </div>
    </section>;
}